import React, { Component } from 'react'
import { connect } from 'react-redux'
import ValidatorContainer from './ValidatorContainer'
import UserContainer from './UserContainer'

/**
 * InvoiceContainer — feature-gated entry point for the Invoice module.
 *
 * Renders ValidatorContainer (manager view) or UserContainer (salesperson view)
 * depending on `campaignUser.canInvoiceValidate`.
 *
 * The flag only exists once BalanceService.getUserPoints resolves — the
 * reducer's initial campaignUser has no such key. Rendering before then would
 * mount the salesperson view for a validator (and its default-tab redirect
 * would drop a /invoice/to_validate deep link), so the decision waits.
 */
class InvoiceContainer extends Component {
  render() {
    const { campaign, campaignUser } = this.props
    if (!campaignUser || !('canInvoiceValidate' in campaignUser)) return null

    const isValidator = campaignUser.canInvoiceValidate

    console.log(" [InvoiceContainer] Validator =>", isValidator, campaignUser)
    return isValidator
      ? <ValidatorContainer campaign={campaign} />
      : <UserContainer campaign={campaign} />
  }
}

const mapStateToProps = (state) => ({
  campaign: state.campaignReducer.campaign,
  campaignUser: state.balanceReducer.campaignUser,
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceContainer)
